module.exports = __webpack_public_path__ + "static/media/IMG_6393.d98cd971.jpg";